import type { FaireProductEntity } from "../../entity_types/product";

export const p_ja6y5kmruk: FaireProductEntity = {
  token: "p_ja6y5kmruk",
  type: "product",
  name: "Thank You Card",
  brandToken: "b_d9x7wck94x",
  brandName: "Real Happy Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/17b2f288638d911dc09f97461e9144e53c6fdd4b8e3e9d92bd4908420ee843d7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4f531ca34863f3e5458583ba64979856e1dfe79f51a2f070b7c961fef6a0d642.png",
    "https://cdn.faire.com/fastly/bbf5e1c5f62397c8f53bd9585f25f7ae0e07c116e778eea6d06258395f47b261.png",
  ],
  priceDollars: 2.44,
  description:
    '4.25" x 5.5" (A2) - 100lb heavyweight cardstock. Blank inside for your own sentiments. Heart to Home logo printed on back of card. Paper envelope included. Each card comes packaged in a protective cellophane sleeve.',
  tags: [],
  msrpDollars: 4.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:33.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
